import { call, put, takeEvery, getContext } from 'redux-saga/effects';
import {
  GO_TO_AI,
  GO_TO_IMAGE,
  GO_TO_SIMILAR_IMAGE,
  GO_TO_RESULT,
  goToAI,
  goToResult,
  goToImage,
  goToSimilarImage,
} from './actions';

function* goToResultSaga(action: ReturnType<typeof goToResult>) {
  const history = yield getContext('history');
  history.push(`/search/result?q=${action.query}`);
}

function* goToAISaga(action: ReturnType<typeof goToAI>) {
  const history = yield getContext('history');
  history.push(`/search/ai?q=${action.query}`);
}

function* goToImageSaga(action: ReturnType<typeof goToImage>) {
  const history = yield getContext('history');
  history.push(`/search/image?q=${action.query}`);
}

function* goToSimilarImageSaga(action: ReturnType<typeof goToSimilarImage>) {
  const history = yield getContext('history');
  history.push(`/search/similarImage?q=${action.query}`);
}

export default function* tabMenuSaga() {
  yield takeEvery(GO_TO_RESULT, goToResultSaga);
  yield takeEvery(GO_TO_AI, goToAISaga);
  yield takeEvery(GO_TO_IMAGE, goToImageSaga);
  yield takeEvery(GO_TO_SIMILAR_IMAGE, goToSimilarImageSaga);
}
